import { render, staticRenderFns } from "./bcAddModel.vue?vue&type=template&id=a9ba9fae&scoped=true&"
import script from "./bcAddModel.vue?vue&type=script&lang=js&"
export * from "./bcAddModel.vue?vue&type=script&lang=js&"
import style0 from "./bcAddModel.vue?vue&type=style&index=0&id=a9ba9fae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ba9fae",
  null
  
)

export default component.exports